import React from 'react';
import {
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import axios from 'axios';

const AddSchool = () => {
  const [userType, setUserType] = React.useState('SCHOOL');
  const [userData, setUserData] = React.useState({
    name: '',
    email: '',
    password: '',
    role: 'SCHOOL',
    dob: '',
    confirmPassword: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });

    if (name === 'role') setUserType(value);
  };



  

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userData.password !== userData.confirmPassword)
      return alert('Passwords do not match');

    try {
      const response = await axios.post('/users', userData);
      console.log(response);
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        const { message } = error.response.data;
        return alert('Error: ' + message);
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
        alert('Error: ' + error.message);
      }

      return alert('Something went wrong, please try again later');
    }
  };

  return (
 <div heading={'Add SCHOOL'}>
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '40%',
            padding: '10px',
            margin: 'auto',
          }}
        >
          <h2
            style={{
              alignText: 'center',
              paddingTop: '18px',
              paddingBottom: '18px',
              textAlign: 'center',
              backgroundColor: '#3f51b5',
              color: 'white',
            }}
          >
            Register a new SCHOOL
          </h2>

          <FormControl
            fullWidth
            style={{
              marginBottom: '10px',
            }}
          >
            <MenuItem value='SCHOOL' selected={true}>School</MenuItem>

              

          </FormControl>

          {userType === 'SCHOOL' && (
            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
            </FormControl>
          )}

          <div
            style={{
              marginBottom: '10px',
            }}
          >
            <TextField
              fullWidth
              id='name'
              name='name'
              label='Name'
              variant='outlined'
              required
              onChange={handleChange}
            />
          </div>

          

          <div
            style={{
              marginBottom: '10px',
            }}
          >
            <TextField
              id='email'
              name='email'
              type='email'
              label='Email'
              variant='outlined'
              fullWidth
              required
              onChange={handleChange}
            />
          </div>

          

          <FormControl
            fullWidth
            style={{
              marginBottom: '10px',
            }}
          >   

          </FormControl>

          <FormControl
            fullWidth
            style={{
              marginBottom: '10px',
            }}
          >
            <InputLabel id='demo-simple-select-label'>Educational Level</InputLabel>
            <Select
              id='level'
              name='level'
              label='Level'
              onChange={handleChange}
            >
              <MenuItem value='University'>University</MenuItem>
              <MenuItem value='HighSchool'>HighSchool</MenuItem>
              <MenuItem value='Primary School'>Primary School</MenuItem>
            </Select>
          </FormControl>

          <div
            style={{
              marginBottom: '10px',
            }}
          >
            <TextField
              id='Region'
              name='Region'
              label='Region'
              variant='outlined'
              fullWidth
              required
              onChange={handleChange}
            />
          </div>

          <div
            style={{
              marginBottom: '10px',
            }}
          >
            <TextField
              id='password'
              name='password'
              label='Password'
              variant='outlined'
              fullWidth
              required
              type='password'
              onChange={handleChange}
            />
          </div>

          <div
            style={{
              marginBottom: '10px',
              width: '100%',
            }}
          >
            <TextField
              id='confirmPassword'
              name='confirmPassword'
              label='Confirm password'
              variant='outlined'
              fullWidth
              required
              type='password'
              onChange={handleChange}
            />
          </div>

          <Button type='submit' variant='contained'>
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddSchool;
